import {Actions, Effect, ofType} from '@ngrx/effects';
import * as fromUserState from './user.actions';
import {
  LOAD_USER,
  SAVE_USER_TO_EDIT,
  SAVED_USER,
  SavedUser,
  SaveUserError,
  SaveUserToEdit,
  SaveUserToEditFinished, SEARCH_USER, SearchUser, SearchUserFinished,
  UserActions
} from './user.actions';
import {Observable, of} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {FullUser, Image} from '../model';
import {UserService} from '../services';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../app.store';
import {SharedToastService} from '../../shared/shared/toast.service';
import {Router} from '@angular/router';
import {SearchService} from '../../search/service/search.service';

@Injectable()
export class UserEffects {


  constructor(private actions$: Actions,
              private userService: UserService,
              private searchService: SearchService,
              private store: Store<AppState>,
              private toastService: SharedToastService,
              private router: Router
) {
  }

  @Effect()
  saveSettings$: Observable<UserActions> = this.actions$.pipe(
    ofType(fromUserState.SAVING_USER),
    map((action: fromUserState.SavingUser) => action.payload),
    switchMap((user: { user: FullUser, file: File }) => {
      return of(user).pipe(
        switchMap(aUser => this.userService.saveUserImage(aUser.user.displayName, aUser.file)),
        switchMap((img: Image) => {
          if ( img ) {
            user.user.image = img;
          }
          return this.userService.saveUser(user.user);
          }),
        map(() => user.user),
        map((aUser: FullUser) => {
          this.toastService.info({title: 'Saved', msg: `${aUser.displayName} saved successfully`});
          return new SavedUser(aUser);
        }),
        catchError((error) => {
          console.log('error', error);
          return of(new SaveUserError(error.message));
        }));
    }),
  );

  @Effect()
  loadUser$: Observable<UserActions> = this.actions$.pipe(
    ofType(fromUserState.LOAD_USER),
    map((action: fromUserState.LoadUser) => action.payload),
    switchMap((userId: string ) => {
      return of(userId).pipe(
        switchMap(id => this.userService.fetchUser(id)),
        switchMap((user: FullUser) => of(new fromUserState.LoadUserFinished(user))),
        catchError(error => of(new fromUserState.LoadUserError(error)))
      );
    } )
  );

  @Effect()
  loadUserToEdit$: Observable<UserActions> = this.actions$.pipe(
    ofType(fromUserState.LOAD_USER_TO_EDIT),
    map((action: fromUserState.LoadUser) => action.payload),
    switchMap((userId: string ) => {
      return of(userId).pipe(
        switchMap(id => this.userService.fetchUser(id)),
        switchMap((user: FullUser) => of(new fromUserState.LoadUserToEditFinished(user))),
        catchError(error => of(new fromUserState.LoadUserError(error)))
      );
    } )
  );

  @Effect({dispatch: false})
  saveFinished$ = this.actions$.pipe(
    ofType(SAVED_USER),
    map(( action: SavedUser) => action.payload),
    map((user: FullUser) => {
      console.log('saved finished, navigating to ', user);
      this.router.navigate(['/users', user.displayName]);
    })
  );

  @Effect()
  saveUserToEdit$ = this.actions$.pipe(
    ofType(SAVE_USER_TO_EDIT),
    switchMap((action: SaveUserToEdit) => {
      return of(action).pipe(
        switchMap(act => this.userService.saveUserToEdit(act.payload)),
        map((fullUser: FullUser) => {
          this.toastService.info({title: 'Saved', msg: `${fullUser.displayName} saved successfully`});
          return new SaveUserToEditFinished(fullUser);
        }));
    }
  ));

  @Effect()
  searchUser$ = this.actions$.pipe(
    ofType(SEARCH_USER),
    switchMap((action: SearchUser) => {
      return of(action).pipe(
        switchMap(act => this.searchService.search(act.payload)),
        tap(u => console.log('search finished ', u)),
        map(users =>  new SearchUserFinished(users))
      );
    })
  );
}
